import { FC } from 'react'
import useHomeStockStore from '../../store/home/useHomeStockStore'
import { BaseModalFooter } from '../common/Modal'
import { useStock } from '../../hooks/useStock'
import { assignSchools } from '../../api/group/group.service'
import { reloadGroupsWithSchoolsAndTanks } from '../../utils/loadStorage'
import { validateStockGroups } from '../../utils/stockGroupValidation'
import { UNGROUPED_KEY } from './GroupDropdown'

type InitialInfoButtonProps = {
  onClose: () => void
  isBack: () => void
}

export const InitialInfoButton: FC<InitialInfoButtonProps> = ({ onClose, isBack }) => {
  const { setTanksInfoBorderColor, stockData, typeError, validationErrors, groupSelections, setValidationErrors, tanksValues } =
    useHomeStockStore()
  const stockMutation = useStock()

  const chekTanksValuesBeforeFinish = () => {
    setTanksInfoBorderColor()

    // Validate group selection (required for all tanks)
    const tankNames = tanksValues.map((t) => t.tankName ?? '')
    const groupResult = validateStockGroups(groupSelections, tankNames)
    setValidationErrors(groupResult.errors)
    if (!groupResult.isValid) return

    if (
      stockData &&
      stockData.every((item) => item.count !== null && item.moveDate !== null && !!item.batchInput) &&
      !typeError
    ) {
      stockMutation.mutate(stockData, {
        onSuccess: async (stockResults) => {
          // groupId → tankId[] 매핑 구성 (ungrouped 제외)
          const groupedTankIds: Record<string, string[]> = {}
          for (let i = 0; i < stockData.length; i++) {
            const selection = groupSelections[i]
            if (selection?.groupId && selection.groupId !== UNGROUPED_KEY) {
              if (!groupedTankIds[selection.groupId]) {
                groupedTankIds[selection.groupId] = []
              }
              groupedTankIds[selection.groupId].push(stockData[i].tankId)
            }
          }

          try {
            if (Object.keys(groupedTankIds).length > 0) {
              // stock-fry 응답에서 tankId → schoolId 매핑 구성
              const tankToSchoolId: Record<string, string> = {}
              for (const result of stockResults) {
                tankToSchoolId[result.tankId] = result.schoolId
              }

              // groupId별로 schoolIds 모아서 assign-schools 호출
              for (const [groupId, tankIds] of Object.entries(groupedTankIds)) {
                const schoolIds = tankIds
                  .map((tankId) => tankToSchoolId[tankId])
                  .filter((id): id is string => !!id)

                if (schoolIds.length > 0) {
                  await assignSchools({ groupId, schoolIds, reason: 'Assigned during stocking' })
                }
              }
            }

            // 최종 store 갱신
            await reloadGroupsWithSchoolsAndTanks()
          } catch (error) {
            console.error('Failed to process groups after stocking:', error)
          }

          onClose()
        },
        onError: () => {
          // Keep modal open on error — useStock's onError shows toast
        },
      })
    }
  }

  return (
    <BaseModalFooter
      back="Back"
      next="Finish"
      backOnPress={() => {
        onClose()
        isBack()
      }}
      nextOnPress={chekTanksValuesBeforeFinish}
    />
  )
}
